/* Made by Juan Bedoya (https://bedoya.dev) */
import { ViteReactSSG } from "vite-react-ssg";
import RootProviders from "./RootProviders";
import routes from "./routes";
import { initSentry } from "@/lib/sentry";
import { initTracking } from "@/lib/tracking";
import "./index.css";

export const createRoot = ViteReactSSG(
  { routes: [{ element: <RootProviders />, children: routes }] },
  ({ isClient }) => {
    if (isClient) {
      initSentry();
      initTracking();
    }
  },
);
